import { defineProperty as _defineProperty, objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import { THEME_UI_DEFAULT_KEY } from '@costar/theme-ui';

var _anchors;
var hoverUnset = {
  color: 'inherit',
  bg: 'transparent',
  cursor: 'pointer',
  p: 'unset',
  textDecoration: 'none',
  '&.is-disabled': {
    pointerEvents: 'none'
  }
};
var disabled = {
  '&.is-disabled': {
    color: 'neutral.medium',
    cursor: 'not-allowed'
  }
};
var hover = {
  '&:hover:not(.is-disabled):not(.is-toggled):not(.disable-hover), &:active:not(.is-disabled):not(.is-toggled):not(.disable-hover)': {
    textDecoration: 'underline',
    opacity: 1,
    cursor: 'pointer',
    color: 'primary' //prevent global overwrite
  }
};
var anchors = (_anchors = {}, _defineProperty(_anchors, THEME_UI_DEFAULT_KEY, _objectSpread2(_objectSpread2({
  color: 'primary',
  fontWeight: 'body'
}, hover), {}, {
  '&:visited:not(.is-disabled)': {
    color: 'primary'
  },
  '&:focus-visible': {
    outline: 'primary',
    outlineOffset: '0',
    borderRadius: 'default'
  },
  '&:active': {
    outline: 'none'
  }
}, disabled)), _defineProperty(_anchors, 'no-hover', hoverUnset), _defineProperty(_anchors, "icon", {
  color: 'neutral.dark',
  '&:hover': {
    opacity: '0.6',
    color: 'neutral.dark' //prevent global overwrite
  }
}), _anchors);

export { anchors, hover, hoverUnset };
//# sourceMappingURL=anchors.esm.js.map
